module.exports = __webpack_public_path__ + "media/images/lb/099-9c9f332f9ef68d5be85318468e7e216c.svg";